function syncFrameHeightHandle(frameHeight, neededWidth) {
    const parentElement = document.getElementById('slots-canvas');

    if(Config.lastResolutionSend === Math.round(neededWidth)) {
        return;
    }

    var currentWidth = Config.resolutionX;
    var currentHeight = Config.resolutionY;
    
    if(!Config.isDesktop && Config.windowHeight > Config.windowWidth) {
        currentWidth = Config.resolutionX_portrait;
        currentHeight = Config.resolutionY_portrait;
    }

    if (General.is_iframe()) {
        if(neededWidth) {
            document.getElementsByClassName("slots-wrapper")[0].style.width = `${neededWidth}px`;
        } else {
            document.getElementsByClassName("slots-wrapper")[0].style.width = `100%`;
        }

        let ratio = currentWidth / neededWidth;
        let canvasHeight = currentHeight / ratio;

        if (!Config.isDesktop && Config.max_height) {
            canvasHeight = Math.min(canvasHeight, Config.max_height);

            if (canvasHeight == Config.max_height) {
                const adjustedWidth = canvasHeight * (currentWidth / currentHeight);
                document.getElementsByClassName("slots-wrapper")[0].style.width = adjustedWidth + 'px';
            }
        }

        document.getElementById("slots-container").style.height = `${canvasHeight}px`;
        let height = document.body.clientHeight;

        if (Config.height_offset) {
            height += parseInt(Config.height_offset);
        }

        parent.postMessage({ height }, '*');
        Config.lastResolutionSend = Math.round(neededWidth);
    } else {
        const navigationHeight = document.getElementsByClassName("game-navigation")[0] ? document.getElementsByClassName("game-navigation")[0].offsetHeight : 0;
        let maxHeight = window.innerHeight - navigationHeight;

        if (!Config.isDesktop && Config.max_height) {
            maxHeight = Math.min(maxHeight, Config.max_height);
        }

        let neededWidth = (Config.resolutionX / Config.resolutionY  * maxHeight);

        if(Config.windowHeight > Config.windowWidth) {
            neededWidth = Config.resolutionY / Config.resolutionX  * maxHeight;
        }

        if(neededWidth > Config.windowWidth) {
            neededWidth = Config.windowWidth;
        }

        document.getElementsByClassName("slots-wrapper")[0].style.maxWidth  = `${neededWidth}px`;
        document.getElementsByClassName("slots-wrapper")[0].style.width = `100%`;
        //parentElement.style.marginTop = `-${navigationHeight/2}px`;

        let ratio = currentWidth / neededWidth;
        let canvasHeight = currentHeight / ratio;

        document.getElementById("slots-container").style.height = `${canvasHeight}px`;
    }
}

const isDesktop = () => {
    /* Storing user's device details in a variable*/
    let details = navigator.userAgent;
  
    /* Creating a regular expression 
    containing some mobile devices keywords 
    to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;

    /* Using test() method to search regexp in details
    it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice || isIpadOS()) {
        return false;
    } else {
        return true;
    }
}

const isIpadOS = () => {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}

const syncFrameHeight = syncFrameHeightHandle;

export { syncFrameHeight, isDesktop };